import React from "react";
import { PanelLayout } from "../Panel/Panel";
import { SpacingCustom } from "../Spacing/SpacingCustom";
import { SeparatorLine } from "../../shared/Separators/SeparatorLine";
import { TColorRole } from "../../../types/types";

interface IGridTableProps {
    children: React.ReactNode;
    gridTemplateColumns?: string;
    hasSeparator?: boolean;
    bgColor?: TColorRole,
    alignV?:'start' | 'end' | 'center',
    gap?:number
}

export const GridTable:React.FC<IGridTableProps> = ({children, gridTemplateColumns, hasSeparator = true, bgColor = "white", alignV = 'center', gap = 0.5}) => {
    return (
        <PanelLayout color={bgColor} hasShadow={false} borderIntensity={0} stretch>
            <SpacingCustom marginRight={0.5}>
                <div style={{ display: 'grid', gridTemplateColumns: gridTemplateColumns, alignItems: alignV, gap: `${gap}rem`, }}>
                    {children}
                </div>
                {hasSeparator && <SeparatorLine paddingTop={1}/>}
            </SpacingCustom>
        </PanelLayout>
    )
}